import { InterestByFixedPeriod } from '../Interface/Response/Interest/InterestByFixedPeriod';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { CellDecorator } from '../Enum/TableDecorator';
import { isEmpty } from '../Helpers/String';

const reduceTableByFixedPeriodData = (interests: InterestByFixedPeriod): InterestTableDTO => {
    const headers: HeaderCell[] = interests.periods.map(period => ({
        value: period.name,
        prop: period.name,
        sortable: true,
    }));

    headers.unshift({
        value: 'Product',
        prop: 'product',
        sortable: true,
    });

    headers.unshift({
        value: '',
        prop: 'company',
    });

    const data = interests.labels.reduce((acc: Row[], curValue) => {
        if (curValue.interests.every(({ percentage }) => isEmpty(percentage))) {
            return acc;
        }

        const cells: Cell[] = [];
        cells.push({ value: curValue.finDataCode, decorator: CellDecorator.CompanyIcon });
        cells.push({ value: curValue.name });
        curValue.interests.forEach(interest =>
            cells.push({
                value: interest,
                decorator: CellDecorator.Interest,
            }),
        );
        acc.push({ cells });

        return acc;
    }, []);

    return { data, headers };
};

export default reduceTableByFixedPeriodData;
